import { useCollection } from "@/api/hooks";
import { useSetCollectionVisibilityMutation } from "@/api/api";
import { Switch } from "../switch";
import { Field, FieldContent, FieldDescription, FieldLabel } from "../field";

export default function CollectionVisibility() {
  const collection = useCollection();
  const [setVisibility] = useSetCollectionVisibilityMutation();

  if (!collection) return null;

  const handleToggle = (isPublic: boolean) => {
    setVisibility({ collectionID: collection.id, isPublic });
  };

  return (
    <Field orientation="horizontal">
      <FieldContent>
        <FieldLabel
          htmlFor="collectionVisibility"
          className="text-[13.5px] font-semibold"
        >
          Public
        </FieldLabel>
        <FieldDescription className="text-[12px]">
          Anyone can view this collection
        </FieldDescription>
      </FieldContent>
      <Switch
        id="collectionVisibility"
        checked={collection.is_public}
        onCheckedChange={handleToggle}
      />
    </Field>
  );
}
